import {format, parse} from "date-fns";

export default {
    getTax() {
        return Number(window.config.tax / 100);
    },
    taxApply(sum) {
        return Number(sum * (1 + this.getTax()));
    },
    taxCost(sum) {
        return Number(sum * this.getTax());
    },
    formatDate(dateStr, formatString = 'dd.MM.yyy HH:mm') {
        if (!dateStr) return null;
        const date = parse(dateStr, 'yyyy-MM-dd HH:mm:ss', new Date());
        return format(date, formatString);
    }
}
